module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Food/Carrot-b824e6a90ae4f2551be77b22148f9d54.svg";